import React from 'react';

const PayPal = () => (
  <svg
    width="21"
    height="22"
    viewBox="0 0 21 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.6266 5.88648C15.8287 4.59586 15.6354 3.77161 14.9686 3.01211H14.9677C14.2616 2.20798 12.9202 1.79761 11.0101 1.79761H5.78113C5.37188 1.79785 5.0237 2.09592 4.96038 2.50023L2.68713 16.9465C2.6848 16.9595 2.68833 16.9728 2.69677 16.9829C2.70521 16.9931 2.71769 16.9989 2.73088 16.999H5.82663L6.64038 11.8417L6.65263 11.8435C6.81012 11.329 7.28613 10.9667 7.83738 10.9667H9.48588C12.8695 10.9667 14.9293 9.50286 15.5724 6.20148C15.5916 6.09648 15.61 5.99411 15.6266 5.88648ZM17.8211 10.377C18.0451 9.22811 17.9891 8.23586 17.5586 7.46586C16.6434 11.2275 13.9554 13.1551 9.86212 13.1551H8.65025L7.819 18.4226H6.49075L6.33763 19.393C6.31844 19.515 6.35361 19.6393 6.43388 19.7332C6.51414 19.8271 6.63147 19.8812 6.755 19.8812H9.68013C10.0264 19.8811 10.321 19.6291 10.3749 19.2871L10.4029 19.1384L10.9541 15.6445L10.9891 15.452C11.0429 15.1098 11.3375 14.8575 11.6839 14.857H12.1214C14.9546 14.857 17.1736 13.7072 17.8211 10.377Z"
      fill="white"
    />
  </svg>
);

export default PayPal;
